import { LANDING_PAGES } from './landing';
import { POSTS } from './posts';

export interface SeoRoute {
	/** Site-relative path, leading slash, no trailing slash (except '/'). */
	path: string;
	/** Sitemap hint. */
	changefreq: 'daily' | 'weekly' | 'monthly' | 'yearly';
	/** Sitemap priority, 0.0–1.0. */
	priority: number;
	/** ISO date for <lastmod>, where known. */
	lastmod?: string;
}

/**
 * The routes that get snapshotted to static HTML at build time and listed in
 * sitemap.xml.
 *
 * Deliberately excludes the catalogue (/products, /products/:type/:id) and all
 * authenticated or token-gated pages. Catalogue pages change whenever Printify
 * syncs, so baking them into static HTML would serve stale prices; they remain
 * client-rendered and are added to the sitemap separately by the build script
 * if a product feed is available.
 */
export const SEO_ROUTES: SeoRoute[] = [
	{ path: '/', changefreq: 'weekly', priority: 1.0 },
	...LANDING_PAGES.map(
		(p): SeoRoute => ({ path: p.path, changefreq: 'monthly', priority: 0.9 }),
	),
	{ path: '/blog', changefreq: 'weekly', priority: 0.7 },
	...POSTS.map(
		(p): SeoRoute => ({
			path: `/blog/${p.slug}`,
			changefreq: 'yearly',
			priority: 0.6,
			lastmod: p.updated || p.date,
		}),
	),
	{ path: '/privacy', changefreq: 'yearly', priority: 0.2 },
	{ path: '/terms-of-sale', changefreq: 'yearly', priority: 0.2 },
	{ path: '/refund-policy', changefreq: 'yearly', priority: 0.2 },
	{ path: '/terms', changefreq: 'yearly', priority: 0.2 },
];

/**
 * Publish the manifest on `window` so scripts/prerender.js can read it from a
 * live page instead of importing TypeScript from Node. This keeps a single
 * source of truth for "which routes matter for SEO" without a codegen step.
 */
export const exposeSeoRoutes = () => {
	if (typeof window !== 'undefined') {
		window.__SEO_ROUTES__ = SEO_ROUTES;
	}
};

declare global {
	interface Window {
		__SEO_ROUTES__?: SeoRoute[];
	}
}

export default SEO_ROUTES;
